__turbopack_context__.v({
  "buttonContainer": "styles-module-scss-module__tM-cWG__buttonContainer",
  "marketingConsent": "styles-module-scss-module__tM-cWG__marketingConsent",
});
